import styled from "@emotion/styled";
import CoverImage from '../../../assets/mask.png';
import Background from '../../../assets/background.jpg';
import {themeColor} from '../../layout/global-style';


export const CoverPageContainer = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  flex-flow: row wrap;
  width: 100%;
  flex: 1 0 100%;
  background-image: url(${Background});
  background-repeat: no-repeat;
  background-position: bottom center;
  background-size: cover;
  background-attachment: fixed;
  height: ${ (props) => props.height };
  position: relative;
  background-color: ${themeColor.white};

  @media screen and (orientation: portrait) {
    overflow:auto;
-webkit-overflow-scrolling:touch;
    
  }
  @media screen and (max-height: 300px) {
    overflow-y: auto;
  }

  .title {
    span {
      font-size: 10vw;
      @media screen and (max-width: 768px) and (orientation: portrait) {
        font-size: 114px;
      }
      @media screen and (max-width: 540px) and (orientation: portrait) {
        font-size: 80px;
      }
      @media screen and (max-width: 360px) and (orientation: portrait) {
        font-size: 70px;
      }
    }
  }
`

export const CoverPageWrapper = styled.div`
  max-width: 1920px;
  margin: 0 auto;
  display: flex;
  width: 100%;
  position: relative;
  align-items: center;
  justify-content: center;
  align-content: center;
  min-height: 100%;
  flex-flow: row wrap;
`;

export const CoverPageImage = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  background-image: url(${CoverImage});
  background-repeat: no-repeat;
  background-position: left top;
  background-size: auto 100%;
  max-width: 1920px;
  @media screen and (orientation: portrait) {
    position: relative;
    padding-bottom: 50vh;
    width: 100%;
    background-position: 80% top;
  }
  @media screen and (max-width: 1919px) and (orientation: landscape) {
    
  }

  @media screen and (max-width: 768px) and (orientation: portrait) {
    margin-bottom: 14px;
  }

  @media screen and (max-width: 540px) and (orientation: portrait) {
    padding-bottom: 34vh;
    background-position: 80% top;
  }

  @media screen and (max-width: 1024px) and (min-height: 680px) and (orientation: landscape) {
    max-width: 46vw;
    width: 100%;
    padding-bottom: 37.3vw;
    background-size: 100% auto;
    margin: 0 auto;
    position: relative;
  }
`

export const CoverPageContent = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: center;
  flex-flow: row wrap;
  max-width: 788px;
  color: ${themeColor.black};
  position: relative;
  z-index: 0;
  margin-right: 124px;
  margin-bottom: 128px;
  h1 {
    font-size: 123px;
    margin-bottom: 10px;
    width: 100%;
    @media screen and (max-width: 1919px) and (orientation: landscape) {
      font-size: 6vw;
      margin-bottom: .54vw;
    }
    @media screen and (max-width: 1366px) and (min-height: 950px) and (max-height: 1024px) {
      font-size: 5.8vw;
    }
    @media screen and (max-width: 768px) and (orientation: portrait) {
      font-size: 80px;
      margin-bottom: 4px;
    }
    @media screen and (max-width: 540px) and (orientation: portrait) {
      font-size: 48px;
    }
    @media screen and (max-width: 1024px) and (orientation: landscape) {
      font-size: 6vw;
    }
    @media screen and (max-width: 360px) and (orientation: portrait) {
      font-size: 42px;
    }
  }

  > p {
    @media screen and (max-width: 1919px) and (orientation: landscape) {
      font-size: 1.46vw;
      margin-bottom: 1.02vw;
    }
    @media screen and (max-width: 768px) and (orientation: portrait) {
      font-size: 28px;
    }
    @media screen and (max-width: 540px) and (orientation: portrait) {
      font-size: 20px;
      line-height: 120%;
    }
    @media screen and (max-width: 1024px) and (orientation: landscape) {
      font-size: 2.2vw;
    }
  }

  @media screen and (orientation: portrait) {
    max-width: 100%;
    margin-right: 0;
    margin-bottom: 3vw;
  }

  @media screen and (max-width: 1919px) and (orientation: landscape) {
    max-width: 42vw;
    margin-right: 0.45vw;
  }

  @media screen and (max-width: 1024px) and (orientation: landscape) {
    margin-right: 1.45vw;
    margin-bottom: 2.68vw;
  }

  @media screen and (max-width: 1366px) and (min-height: 950px) and (max-height: 1024px) {
    margin-right: 1.2vw;
  }

  @media screen and (max-width: 1270px) and (min-height: 870px) and (max-height: 930px) and (orientation: landscape) {
    margin-right: 3vw;
  }

  @media screen and (max-width: 1270px) and (min-height: 931px) and (max-height: 1024px) and (orientation: landscape) {
    margin-right: 1vw;
  }

  @media screen and (max-width: 540px) and (orientation: portrait) {
    padding: 0 18px;
  }

  @media screen and (max-width: 1024px) and (max-height: 679px) and (orientation: landscape) {
    max-width: 50vw;
  }

  @media screen and (max-width: 1024px) and (min-height: 680px) and (orientation: landscape) {
    max-width: 60vw;
    margin: 0 auto;
  }

  .btn.btn--default.btn--bottom-label  {
    .btn__bottom-right::after{
      color: ${themeColor.black};
    }
    .btn__content {
      @media screen and (max-width: 1919px) and (orientation: landscape) {
        padding-left: 1.56vw;
        padding-right: .73vw;
        padding-top: .63vw;
        > div {
          width: 1.67vw;
  
          svg {
            width: 1.67vw;
            height: 1.67vw;
          }
        }
      }
      @media screen and (max-width: 1024px) and (orientation: landscape) {
        padding-right: 1vw;
        > div {
          width: 2vw;
          svg {
            width: 2vw;
            height: 2vw;
          }
        }
      }
      @media screen and (max-width: 1024px) and (orientation: landscape) and (max-height: 600px) {
        > div {
          width: 2.5vw;
          svg {
            width: 2.5vw;
            height: 2.5vw;
          }
        }
      }

      @media screen and (max-width: 768px) and (orientation: portrait){
        padding-left: 22px;
      }
      .btn__text {
        @media screen and (max-width: 1919px) and (orientation: landscape) {
          font-size: 1.46vw;
          padding-right: .53vw;
        }
        @media screen and (max-width: 1024px) and (orientation: landscape) {
          font-size: 2.3vw;
          padding-right: 0;
        }

        @media screen and (max-height: 320px) and (orientation: landscape) {
          font-size: 2.1vw;
        }
        @media screen and (max-width: 768px) and (orientation: portrait) {
          font-size: 20px;
        }
        @media screen and (max-width: 360px) and (orientation: portrait) {
          font-size: 20px;
        }
      }
    }
    .btn__bottom {
      &-left {
        @media screen and (max-width: 1919px) and (orientation: landscape) {
          width: .83vw;
          height: .83vw;
          border-top-width: .83vw;
          border-left-width: .83vw;
        }
        @media screen and (max-width: 1024px) and (orientation: landscape) {
          width: 1.1vw;
          height: 1.1vw;
          border-top-width: 1.1vw;
          border-left-width: 1.1vw;
        }
        @media screen and (max-width: 1024px) and (orientation: landscape) and (max-height: 600px) {
          width: 1.1vw;
          height: 1.1vw;
          border-top-width: 1.1vw;
          border-left-width: 1.1.vw;
        }
      }
      &-center {
        @media screen and (max-width: 1919px) and (orientation: landscape) {
          height: .83vw;
          width: calc(100% - .83vw - 2.1vw);
        }
        @media screen and (max-width: 1024px) and (orientation: landscape) {
          height: 1.1vw;
          width: calc( 100% - 1.1vw - 3.1vw);
        }
        @media screen and (max-width: 1024px) and (orientation: landscape) and (max-height: 600px) {
          height: 1.1vw;
          width: calc(100% - 1.1vw - 3.1vw);
        }
      }
      &-right {
        @media screen and (max-width: 1919px) and (orientation: landscape) {
          width: 2.1vw;
          height: .83vw;
          border-right-width: .83vw;
          border-top-width: .47vw;
          &:after {
            font-size: .52vw;
            bottom: -.36vw;
            left: .26vw;
          }
        }

        @media screen and (max-width: 1024px) and (orientation: landscape) {
          width: 3.1vw;
          height: 1.1vw;
          border-right-width: 1.1vw;
          border-top-width: .37vw;
          &:after {
            font-size: .72vw;
            bottom: - .56vw;
            left: .46vw;
          }
        }

        @media screen and (max-width: 1024px) and (orientation: landscape) and (max-height: 600px) {
          width: 3.1vw;
          height: 1.1vw;
          border-right-width: 1.1vw;
          border-top-width: .37vw;
          &:after {
            font-size: .72vw;
            bottom: - .56vw;
            left: .46vw;
          }
        }
      }
    }

  } 
`

export const CoverPageListContainer = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: center;
  flex: 1 0 100%;
  width: 100%;
  margin-top: 26px;
  flex-flow: row wrap;

  @media screen and (max-width: 1919px) and (orientation: landscape) {
    margin-top: 1.35vw;
  }

  @media screen and (max-width: 768px) and (orientation: portrait) {
    margin-top: 16px;
    padding: 0 48px;
  }

  @media screen and (max-width: 660px) and (orientation: portrait) {
    padding: 0 20px;
  }

  @media screen and (max-width: 540px) and (orientation: portrait) {
    padding: 0;
  }
`

export const CoverPageSingleList = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 1 50%;
  width: 50%;
  max-width: 50%;
  flex-flow: row wrap;
  padding: 0 24px;

  @media screen and (max-width: 1919px) and (orientation: landscape) {
    padding: 0 1.25vw;
  }

  @media screen and (max-width: 590px) and (orientation: portrait) {
    flex: 1 0 100%;
    width: 100%;
    max-width: 100%;
    margin-bottom: 16px;
  }

  @media screen and (max-width: 1024px) and (orientation: landscape) {
    padding: 0 12px;
  }
  
  ul {
    margin: 20px 0 0 30px;
    @media screen and (max-width: 1919px) and (orientation: landscape) {
      margin: 1.04vw 0 0 1.56vw;
      padding: 0 0 0 1.04vw;
    }
    li {
      @media screen and (max-width: 1919px) and (orientation: landscape) {
        margin-bottom: 0.1vw;
        span {
          top: 0.21vw;
          width: 1.05vw;
          height: 1.05vw;
          svg {
            width: 1.67vw;
            height: 1.67vw;
          }
        }
        p {
          font-size: .94vw;
          line-height: 1.46vw;
        }
      }
      @media screen and (max-width: 1024px) and (orientation: landscape) {
        margin-bottom: .3vw;
        span {
          top: 0.15vw;
          width: 1.4vw;
          height: 1.4vw;
          svg {}
        }
        p {
          font-size: 1.5vw;
          line-height: 1.7vw;
        }
      }
      @media screen and (max-width: 768px) and (orientation: portrait) {
        margin-bottom: 0;
      }
      @media screen and (max-width: 660px) and (orientation: portrait) {
        font-size: 16px;
      }
      @media screen and (max-width: 1024px) and (orientation: landscape) and (max-height: 600px) {
        span {
          width: 2vw;
          height: 2vw;
          svg {
            width: 2.5vw;
            height: 2.5vw;
          }
        }
        p {
          //font-size: 14px;
          font-size: 1.85vw;
          line-height: 120%;
        }
      }
      @media screen and (max-height: 320px) and (orientation: landscape) {
        p {
          font-size: 1.8vw;
        }
      }
    }
  }
`
export const CoverLogoContainer = styled.div`
  max-width: 305px;
  margin: 0 auto 20px;
  @media screen and (max-width: 1919px) and (orientation: landscape) {
    max-width: 15.9vw;
    margin: 0 auto 1.05vw;
  }
  @media screen and (max-width: 768px) and (orientation: portrait) {
    max-width: 240px;
    margin: 0 auto 7px;
  }
`;
